import React from 'react'
import { useEffect, useState, useRef } from 'react';
import { Drawer } from '@material-ui/core';
import { useDispatch, useSelector  } from "react-redux";
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Divider from '@mui/material/Divider';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Fab from '@mui/material/Fab';
import Badge from '@mui/material/Badge';
import { CardActionArea } from '@mui/material';
import { setrecievemessage } from '../modules/menustore';
import { setsendmessage } from '../modules/menustore';

import { isEmpty, DeepCopy } from '../modules/appLibrary';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';

/*----------------------------------------------------------------------
 * メッセージ
 * show: true:open 
 * doClose : close call back
 -----------------------------------------------------------------------*/
export default function Message(props) {

    const dispatch = useDispatch();
    const recievemsg = useSelector(state => state.menu.recievemsg);
    const sendmsg = useSelector(state => state.menu.sendmsg);
    const [open, setOpen] = useState(false);
    const [windowheight, setwindowheight] = useState(300);
    const [wapperheight, setwapperheight] = useState(300);
    const [value, setValue] = React.useState('1');
    const [more, ] = React.useState({
        recieve: false,
        send: false
    });

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        setOpen(props.show)
        if (props.show) {
            if (recievemsg.length !== 0) {
                let result = recievemsg.find(e => e.end);
                if (isEmpty(result)) more.recieve = true;
            }
            if (sendmsg.length !== 0) {
                let result = sendmsg.find(e => e.end);
                if (isEmpty(result)) more.send = true;
            }
        }
        handleResize();
    }, [props.show])

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    function handleResize() {
        setwindowheight(window.innerHeight);
        let h = window.innerHeight - 150;
        setwapperheight(h);
    }

    function doClose() {
        props.doClose();
    }

    function moremessage(type) {
        //続き取得
        var param = {};
        param['type'] = type;
        if (type === "0") {
            param["date"] = recievemsg[recievemsg.length - 1].date;
            param["fromacc"] = recievemsg[recievemsg.length - 1].fromacc;
        } else {
            param["date"] = sendmsg[sendmsg.length - 1].date;
        }
        props.fnc.current.postaxios('menu/MoreMessage', param,
            {
                onSuccess: function (data) {
                    if (data.sendmsg.length !== 0) {
                        if (type === "0") {
                            let newmsglist = [...recievemsg, ...data.sendmsg];
                            let result = newmsglist.find(e => e.end);
                            if (!isEmpty(result)) more.recieve = false;
                            dispatch(setrecievemessage(newmsglist));
                        }
                        else {
                            let newmsglist = [...sendmsg, ...data.sendmsg];
                            let result = newmsglist.find(e => e.end);
                            if (!isEmpty(result)) more.send = false;
                            dispatch(setsendmessage(newmsglist));
                        }
                    }
                    props.fnc.current.wait(false);
                },
            }
        )
    }

    function SendMessage() {
        props.fnc.current.formdialogopen(
            {
                title: "メッセージ送信", dialogtype: 0,
                inputname:"送信メッセージ",
                placeholder:"送信メッセージを入力してください",
                textarea: true,
                customcontents: 3,  //共有条件 & 重要
                onApply: (param) => Action(param)
            });
        function Action(param) {
            if (param.option !== "0" && isEmpty(param.codes)) {
                props.fnc.current.warnmsg("共有条件が未入力です");
                return;
            }
            props.fnc.current.postaxios('menu/SendMessage',
                {
                    note:param.name,
                    type: param.option,
                    code: param.codes,
                    status:param.check
                },
                {
                    onSuccess: function (data) {
                        var newmsglist = [{ type: param.check?"1":"2", date: data.request, message: param.name, sendtype: param.option, to: param.codes}];
                        newmsglist = [...newmsglist, ...sendmsg];
                        dispatch(setsendmessage(newmsglist));

                        props.fnc.current.formdialogclose();
                        props.fnc.current.success();
                        props.fnc.current.wait(false);
                    },
                }
            )
        }
    }
    function CardClick(msg) {
        if (msg.read === "1") return;
        //既読にする
        props.fnc.current.postaxios('menu/SetRead',
            {
                date: msg.date,
                from: msg.fromacc,
            },
            {
                onSuccess: function (data) {
                    var newmsglist = DeepCopy(recievemsg);
                    var newmsg = newmsglist.find(e => e.date === msg.date && e.from === msg.from);
                    newmsg.read = "1";
                    dispatch(setrecievemessage(newmsglist));
                },
            }
        )
    }

    return (
         <Drawer anchor={"top"} open={open} id="groupspanel">
             <div style={{ display: 'flex', backgroundColor: '#F2F2F2', height:windowheight}}>
                <div style={{ position: 'absolute', top: 0, left: 0 }}>
                <IconButton onClick={doClose} title="閉じる">
                    <Icon style={{ fontSize: 30 }}>close</Icon>
                </IconButton>
                <IconButton onClick={SendMessage} title="メッセージ送信">
                    <Icon style={{ fontSize: 30 }}>send</Icon>
                </IconButton>
                </div>
                 <div style={{ position: 'absolute', top: 20, left: 150, color: '#999999', fontSize: 20 }}>通知メッセージ</div>
                 <Box sx={{ width: '100%', typography: 'body1' , mt:8, ml:10}}>
                     <TabContext value={value}>
                         <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                             <TabList onChange={handleChange} >
                                 <Tab label="受信" value="1" />
                                 <Tab label="送信" value="2" />
                             </TabList>
                         </Box>
                        <TabPanel value="1" sx={{ height: wapperheight, overflowY: 'auto' }}>
                             {recievemsg.map(msg => {
                                 return (
                                     <Card sx={{ minWidth: 275, mb: 1 }}>
                                         <CardActionArea
                                             onClick={()=>CardClick(msg)}
                                         >
                                          <CardContent>
                                             <div style={{ position: 'relative' }}>
                                                 <Badge color="secondary" variant="dot" invisible={msg.read==="1"}>
                                                 {msg.type === "0" ? <Icon>info</Icon> :
                                                         (msg.type === "1" ? <Icon color="primary">announcement</Icon>:<Icon >message</Icon>)
                                                 }
                                                 </Badge>
                                                 <div style={{ position: 'absolute', top: 0, left: 40 }}>
                                                    <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                                        <Box component="span" fontWeight={msg.read === "0" ? "bold" : "normal"}>Date.</Box>
                                                        <Box component="span" fontWeight={msg.read === "0" ? "bold" : "normal"}>{msg.date}</Box>
                                                        <Box component="span" ml={2} fontWeight={msg.read === "0" ? "bold" : "normal"}>from.</Box>
                                                        <Box component="span" fontWeight={msg.read === "0" ? "bold" : "normal"}>{msg.from}</Box>
                                                     </Typography>
                                                 </div>
                                             </div>

                                             <div style={{ marginTop: 2 }}>
                                                 {msg.message.split('\n').map(str => {
                                                     return (
                                                         <Typography variant="body2" >
                                                             {str}
                                                         </Typography>
                                                         )
                                                 })}
                                            </div>
                                         </CardContent>
                                         {/*    <CardActions>*/}
                                         {/*        <Button size="small">リアクション</Button>*/}
                                         {/*    </CardActions>*/}
                                      </CardActionArea>
                                     </Card>
                                 );
                             })}
                            {more.recieve ?
                                <Fab variant="extended" size="small" sx={{ mt: 1 }} title="続き" onClick={() => moremessage('0')}>
                                    more
                                </Fab>
                            : null}
                         </TabPanel>
                        <TabPanel value="2" sx={{ height: wapperheight, overflowY: 'auto' }}>
                            {sendmsg.map(msg => {
                                return (
                                    <Card sx={{ minWidth: 275, mb: 1 }}>
                                        <CardContent>
                                            <div style={{ position: 'relative' }}>
                                                {msg.type === "0" ? <Icon>info</Icon> :
                                                    (msg.type === "1" ? <Icon color="primary">announcement</Icon> : <Icon >message</Icon>)
                                                }
                                                <div style={{ position: 'absolute', top: 0, left: 40 }}>
                                                    <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                                        <span>Date.</span>
                                                        <span>{msg.date}</span>
                                                        <span style={{ marginLeft: 20 }}>to.</span>
                                                        <span>{msg.sendtype === '0' ? "すべて" : (msg.sendtype==='1'?"部課:":(msg.sendtype==='2'?"担当者:":"グループ:"))}</span>
                                                        <span>{msg.to}</span>
                                                    </Typography>
                                                </div>
                                            </div>

                                            <div style={{ marginTop: 2 }}>
                                                {msg.message.split('\n').map(str => {
                                                    return (
                                                        <Typography variant="body2" >
                                                            {str}
                                                        </Typography>
                                                    )
                                                })}
                                            </div>
                                        </CardContent>
                                        {/*    <CardActions>*/}
                                        {/*        <Button size="small">リアクション</Button>*/}
                                        {/*    </CardActions>*/}
                                    </Card>
                                );
                            })}
                            {more.send?
                                <Fab variant="extended" size="small" sx={{ mt: 1 }} title="続き" onClick={() => moremessage('1')}>
                                more
                                </Fab>
                            : null}
                         </TabPanel>
                     </TabContext>
                 </Box>
             </div>


        </Drawer>
    )
}
